import { RefObject, useRef } from "react";

export const useScrollToRef = () => {
  const ref: RefObject<HTMLElement> = useRef(null);

  const scrollTo = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();

    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  };

  return { ref, scrollTo };
};
